import {
  Avatar,
  Box,
  Button,
  Flex,
  Text,
  useColorModeValue,
} from "@chakra-ui/react";
import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const Header = ({
  backgroundHeader,
  backgroundProfile,
  avatarImage,
  name,
  email,
  tabs,
  isLoading,
}) => {
  const textColor = useColorModeValue("gray.700", "white");
  const borderProfileColor = useColorModeValue(
    "white",
    "rgba(255, 255, 255, 0.31)"
  );
  const emailColor = useColorModeValue("gray.400", "gray.300");

  return (
    <Box
      mb={backgroundHeader ? { sm: "205px", md: "75px", xl: "70px" } : "30px"}
      borderRadius="15px"
      px="0px"
      display="flex"
      flexDirection="column"
      justifyContent="center"
      align="center"
    >
      {/* Optional background image */}
      {backgroundHeader && (
        <Box
          bgImage={backgroundHeader}
          w="100%"
          h="300px"
          borderRadius="25px"
          bgPosition="50%"
          bgRepeat="no-repeat"
          bgSize="cover"
        />
      )}

      {/* User Info Card */}
      <Flex
        direction={{ sm: "column", md: "row" }}
        mt={backgroundHeader ? "-80px" : "20px"}
        w={{ sm: "90%", xl: "95%" }}
        justifyContent={{ sm: "center", md: "space-between" }}
        align="center"
        backdropFilter="saturate(200%) blur(50px)"
        boxShadow="0px 2px 5.5px rgba(0, 0, 0, 0.02)"
        border="2px solid"
        borderColor={borderProfileColor}
        bg={backgroundProfile}
        p="24px"
        borderRadius="20px"
        position="relative"
      >
        <Flex
          align="center"
          mb={{ sm: "10px", md: "0px" }}
          direction={{ sm: "column", md: "row" }}
          w={{ sm: "100%" }}
          textAlign={{ sm: "center", md: "start" }}
        >
          {isLoading ? (
            <Skeleton height={"80px"} width={"80px"} borderRadius={"15px"} />
          ) : (
            <Avatar
              me={{ md: "10px" }}
              src={avatarImage}
              w="60px"
              h="60px"
              borderRadius="15px"
              bg="#071D54"
            />
          )}
          <Flex
            direction="column"
            maxWidth="100%"
            my={{ sm: "14px" }}
            ml={isLoading ? "22px" : "0px"}
          >
            <Text
              fontSize={{ sm: "lg", lg: "xl" }}
              color={textColor}
              fontWeight="bold"
              ms={{ sm: "8px", md: "0px" }}
            >
              {isLoading ? <Skeleton width={120} /> : name}
            </Text>
            <Text
              fontSize={{ sm: "sm", md: "md" }}
              color={emailColor}
              fontWeight="semibold"
            >
              {isLoading ? <Skeleton width={180} /> : email}
            </Text>
          </Flex>
        </Flex>

        <Flex
          direction={{ sm: "column", lg: "row" }}
          w={{ sm: "100%", md: "50%", lg: "auto" }}
        >
          {tabs.map((tab, index) => (
            <Button
              key={index}
              p="0px"
              bg="transparent"
              _hover={{ bg: "none" }}
            >
              <Flex
                align="center"
                w={{ sm: "100%", lg: "135px" }}
                bg="hsla(0,0%,100%,.3)"
                borderRadius="15px"
                justifyContent="center"
                py="10px"
                mx={{ lg: index !== 0 ? "1rem" : "0" }}
                boxShadow="inset 0 0 1px 1px hsl(0deg 0% 100% / 90%), 0 20px 27px 0 rgb(0 0 0 / 5%)"
                border="1px solid gray.200"
                cursor="pointer"
              >
                {isLoading ? (
                  <Skeleton circle={true} height={24} width={24} />
                ) : (
                  tab.icon
                )}
                <Text fontSize="xs" color={textColor} fontWeight="bold" ms="6px">
                  {isLoading ? <Skeleton width={60} /> : tab.name}
                </Text>
              </Flex>
            </Button>
          ))}
        </Flex>
      </Flex>
    </Box>
  );
};

export default Header;
